import style from './style.module.css';

import { useSearchProvider } from 'providers/SearchProvider';

import ErrorMessage from 'components/ErrorMessage';
import Modal from 'components/Modal';
import SearchBox from 'components/SearchBox';
import useAuth from 'hooks/useAuth';
import { analytics } from 'lib/analytics';
import { useEffect, useRef } from 'react';

interface SearchModalProps {
  isModalOpen: boolean;
  onCloseCB: () => void;
}

export default function SearchModal({
  isModalOpen,
  onCloseCB,
}: SearchModalProps) {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [user] = useAuth();
  const searchProvider = useSearchProvider();

  const closeModal = () => {
    onCloseCB();
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isModalOpen]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      className={style.searchModal}
      showCloseButton={true}
      title="New Search"
    >
      <SearchBox
        onSubmitCB={async () => {
          closeModal();
          await searchProvider?.searchForm.onSubmit();
          analytics.questionAsked(
            user,
            searchProvider?.searchForm.getSearchText(),
          );
          closeModal();
        }}
        onChangeCB={(ev) => searchProvider?.searchForm.onTextChanged(ev)}
        value={searchProvider?.searchForm.getSearchText() ?? ''}
        isDisabled={searchProvider?.searchForm.isDisabled() ?? false}
        placeholderText="Ask a question or Research a topic..."
        ref={inputRef}
      />
      {Boolean(searchProvider?.searchForm.getErrorMessage()) && (
        <ErrorMessage className={style.errorMessage}>
          {searchProvider?.searchForm.getErrorMessage()}
        </ErrorMessage>
      )}
    </Modal>
  );
}
